import { configureStore, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductDetailsModal } from "../../interfaces/ProductObject";
import { sampleProductsDictionary } from "../../dummyData/SampleProductList";
import MyListingsThunk from "../../services/thunks/MyListingsThunk";
import { resetAllState } from "./resetAllState";

// Define the initial state as a dictionary with productId as keys and ProductDetails as values
type ProductListState = Record<string, ProductDetailsModal>;

const initialState: ProductListState = {};

// Create a slice for ProductListDb
const myListingsSlice = createSlice({
  name: "MyListingsDb",
  initialState,
  reducers: {
    // Action to add or update a product in the store
    insertProduct(
      state: any,
      action: PayloadAction<{
        productId: string;
        productDetail: ProductDetailsModal;
      }>,
    ) {
      const { productId, productDetail } = action.payload;
      if (!state.data) state.data = {};
      state.data[productId] = productDetail;
    },
    // Action to remove a product from the store
    removeProduct(state, action: PayloadAction<string>) {
      delete state[action.payload];
    },
    // Action to clear all products from the store
    clearProducts() {
      return {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(MyListingsThunk.fetchMyListings.pending, (state: any) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(
        MyListingsThunk.fetchMyListings.fulfilled,
        (state: any, action: any) => {
          state.loading = false;
          state.success = true;
          // 🔑 MERGE old + new listings
          state.data = {
            ...(state.data || {}),
            ...(action.payload || {}),
          };
        },
      )
      .addCase(
        MyListingsThunk.fetchMyListings.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.error = action.payload; // Store the error message
          state.success = false;
        },
      )
      .addCase(resetAllState, () => initialState);
  },
});

// Export actions
export const { insertProduct, removeProduct, clearProducts } =
  myListingsSlice.actions;

export default myListingsSlice.reducer;
